import { Outlet, Link } from "react-router-dom";

export const AuthLayout = () => {
  return (
    <div 
      className="min-h-screen bg-obsidian flex items-center justify-center relative overflow-hidden"
      data-testid="auth-layout"
    >
      {/* Background gradient effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-electric-ice-blue/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cool-mint/5 rounded-full blur-3xl" />
      </div>
      
      {/* Content */}
      <div className="relative z-10 w-full max-w-md px-4">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="/assets/app-icon.png" 
              alt="CamPassed" 
              className="w-10 h-10 rounded-xl shadow-lg shadow-electric-ice-blue/30"
            />
            <span className="text-2xl font-bold tracking-[-0.02em] text-cloud-white">
              CamPassed
            </span>
          </Link>
        </div>
        
        {/* Auth Card */}
        <div className="glass rounded-2xl border border-white/[0.08] p-8">
          <Outlet />
        </div>
        
        {/* Footer */}
        <p className="text-center text-sm text-muted-text mt-6">
          Get CamPassed or Get Left Out
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;
